/** @typedef {import('./types.js').NoteContentBlock} NoteContentBlock */
/** @typedef {import('./types.js').NotesRailNoteWire} NotesRailNoteWire */

/** @typedef {'meetingDetail' | 'summary' | 'transcript' | 'myNotes' | 'chat' | 'notes'} NoteDetailTabId */

export const MEETING_NOTE_DETAIL_TABS = [
  { id: 'meetingDetail', label: 'Meeting detail' },
  { id: 'summary', label: 'Summary' },
  { id: 'transcript', label: 'Transcript' },
  { id: 'myNotes', label: 'My Notes' },
  { id: 'chat', label: 'Chat' },
]

export const REGULAR_NOTE_DETAIL_TABS = [
  { id: 'notes', label: 'Notes' },
  { id: 'chat', label: 'Chat' },
]

/** @param {NotesRailNoteWire} note */
export function getNoteDetailTabs(note) {
  return note.kind === 'meeting' ? MEETING_NOTE_DETAIL_TABS : REGULAR_NOTE_DETAIL_TABS
}

/** @param {NotesRailNoteWire} note */
export function getDefaultNoteDetailTab(note) {
  return note.kind === 'meeting' ? 'myNotes' : 'notes'
}

/** @param {NotesRailNoteWire} note @param {NoteDetailTabId} tabId */
export function resolveNoteTabBlocks(note, tabId) {
  if (note.tabContent?.[tabId]?.length) return note.tabContent[tabId]
  const primaryTab = getDefaultNoteDetailTab(note)
  if (tabId === primaryTab && note.content?.length) return note.content
  return [{ type: 'paragraph', text: '' }]
}

/** @param {NotesRailNoteWire} note */
export function getPrimaryNoteTabBlocks(note) {
  const tabId = getDefaultNoteDetailTab(note)
  return resolveNoteTabBlocks(note, tabId)
}
